import { useState } from "react";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { CONTACT } from "@/constants/testIds";

const input = "w-full px-4 py-2.5 rounded-2xl border border-[#E7E0D3] bg-white text-[#1C1917] focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40";
const EMPTY = { name: "", email: "", order_id: "", message: "", website: "" };

export const ContactForm = () => {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF((v) => ({ ...v, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/contact", f);
      setState("sent");
      setF(EMPTY);
    } catch (err) {
      setState("idle");
      toast.error(errMsg(err));
    }
  };

  if (state === "sent") {
    return (
      <div data-testid={CONTACT.success} className="mt-6 rounded-2xl bg-[#EAF2EE] text-[#2F5D4C] p-5 flex gap-3 items-start">
        <CheckCircle2 size={20} className="shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold">Thanks, your message is on its way.</p>
          <p className="text-sm mt-1">We'll reply to the email you gave us. <button data-testid={CONTACT.another} onClick={() => setState("idle")} className="underline">Send another</button></p>
        </div>
      </div>
    );
  }

  return (
    <form data-testid={CONTACT.form} onSubmit={submit} className="mt-6 grid sm:grid-cols-2 gap-3">
      <input data-testid={CONTACT.name} required maxLength={80} value={f.name} onChange={set("name")} placeholder="Your name" aria-label="Your name" className={input} />
      <input data-testid={CONTACT.email} required type="email" value={f.email} onChange={set("email")} placeholder="Your email" aria-label="Your email" className={input} />
      <input data-testid={CONTACT.orderId} maxLength={40} value={f.order_id} onChange={set("order_id")} placeholder="Order number (optional)" aria-label="Order number" className={`${input} sm:col-span-2`} />
      <textarea data-testid={CONTACT.message} required minLength={5} maxLength={3000} rows={5} value={f.message} onChange={set("message")} placeholder="How can we help?" aria-label="Message" className={`${input} sm:col-span-2`} />
      <input type="text" name="website" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="absolute -left-[9999px] w-px h-px opacity-0" aria-hidden="true" />
      <div className="sm:col-span-2 flex flex-wrap items-center gap-3">
        <button data-testid={CONTACT.submit} disabled={state === "sending"} className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#E06D44] text-white font-semibold hover:bg-[#C95B33] disabled:opacity-60 transition-colors">
          {state === "sending" ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Send message
        </button>
        <p className="text-xs text-stone-500">Goes straight to our inbox. We never ask for passwords or card details.</p>
      </div>
    </form>
  );
};
